/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: queue-limiter-list-modal-controller.js
 *
 * Created by psnyder on 2/27/17.
 */
'use strict';

angular.module('prism-ui.queues').controller('QueueLimiterListController',
    function ($scope, $q, $uibModalInstance, uiGridConstants, QueuesViewService, queueId, ModalService,
              NotificationService, PermissionsService) {
        var self = this;

        self.queueMaxActive = null;
        self.selectedLimiterObject = {};

        self.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };


        self.gridColumns = [
            {
                field: 'partner.name',
                displayName: 'Partner',
                suppressRemoveSort: true,
                enableColumnResizing: true,
                sort: {
                    direction: uiGridConstants.ASC,
                    priority: 0
                },
                sortingAlgorithm: function (a, b) {
                    if (a === undefined) {
                        a = '';
                    } else {
                        a = a.toLowerCase();
                    }
                    if (b === undefined) {
                        b = '';
                    } else {
                        b = b.toLowerCase();
                    }
                    return a.localeCompare(b);
                },
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'categoryType.name',
                displayName: 'Category Type',
                enableSorting: false,
                suppressRemoveSort: true,
                enableColumnResizing: false,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'maxActive',
                displayName: 'Max Active',
                enableSorting: false,
                suppressRemoveSort: true,
                enableColumnResizing: false,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            }
        ];

        self.gridOptions = {
            rowSelection: true,
            multiSelect: false,
            enableColumnMenus: false,
            enableFullRowSelection: true,
            enableRowHeaderSelection: false,
            rowHeight: 30,
            minRowsToShow: 5,
            columnDefs: self.gridColumns,
            rowTemplate: '<div ng-dblclick="grid.appScope.queueLimiterController.rowDoubleClicked(row)" ' +
            ' ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ' +
            ' class="ui-grid-cell" ui-grid-cell></div>',
            onRegisterApi: function (gridApi) {
                self.gridApi = gridApi;
                gridApi.selection.on.rowSelectionChanged($scope, self.gridRowSelectionChangedHandler);
            }
        };

        self.gridRowSelectionChangedHandler = function (row) {
            if (row.isSelected) {
                self.selectedLimiterObject = angular.copy(row.entity);
            } else {
                self.selectedLimiterObject = {};
            }
        };

        self.rowDoubleClicked = function (row) {
            ModalService.showQueueLimiterEditModal(row.entity.id, self.queueObject.maxActive, self.saveQueueLimiter);
        };

        self.addQueueLimiter = function () {
            ModalService.showQueueLimiterEditModal(-1, self.queueObject.maxActive, self.saveQueueLimiter);
        };

        self.saveQueueLimiter = function (limiterObj) {
            self.loadingIndicator.show = true;
            QueuesViewService.saveQueueLimiter(limiterObj).then(function (data) {
                self.selectedLimiterObject = {};
                self.setQueuesListModalData();
                self.loadingIndicator.show = false;
            });
        };

        self.setQueuesListModalData = function () {
            self.loadingIndicator.show = true;
            $q.all([
                PermissionsService.isSystemOperator().then(function (isSystemOperator) {
                    self.canClearQueue = isSystemOperator;
                }),
                QueuesViewService.getQueuesListData(queueId).then(function (data) {
                    self.gridOptions.data = data.queueLimiters;
                    self.queueObject = data.queueData;
                    self.originalQueueMaxActive = self.queueObject.maxActive;

                    QueuesViewService.queueLimiters = data.queueLimiters;
                })
            ]).then(function() {
                self.loadingIndicator.show = false;
            });
        };

        self.disableLimiterDeleteButton = function () {
            return angular.equals(self.selectedLimiterObject, {});
        };

        self.deleteQueueLimiter = function () {
            self.loadingIndicator.show = true;
            QueuesViewService.deleteQueueLimiter(self.selectedLimiterObject).then(function (data) {
                self.selectedLimiterObject = {};
                self.setQueuesListModalData();
                self.loadingIndicator.show = false;
            });
        };

        self.deleteMessage = 'Are you sure you want to delete ';
        self.openConfirmModal = function (messageText, title, handler) {
            messageText += self.selectedLimiterObject.name + '?';
            title += ' ' + self.selectedLimiterObject.name + '?';
            ModalService.showMessageModal({
                messageText: messageText,
                pullCancelLeft: true,
                title: title,
                windowClass: 'confirm-modal-sm',
                showOK: true
            }, handler);
        };

        self.disableListComponents = function () {
            return self.modalForm.$dirty;
        };

        self.disableOkButton = function () {
            return self.modalForm.$pristine || self.queueObject.maxActive > 999;
        };

        self.onOk = function () {
            $uibModalInstance.close(self.queueObject);
            QueuesViewService.selectedQueueId = null;
            QueuesViewService.queueLimiters = [];
        };

        self.cancel = function () {
            self.queueObject.maxActive = self.originalQueueMaxActive;
            self.modalForm.$setPristine();
        };

        self.clearQueue = () => {
            ModalService.showMessageModal({
                messageText: 'Are you sure you want to clear this queue?',
                pullCancelLeft: true,
                title: 'Clear Queue',
                windowClass: 'confirm-modal-sm',
                showOK: true
            }, () => {
                QueuesViewService.clearQueue(queueId).then((clearedQueue) => {
                    NotificationService.createSuccessNotification(`Successfully cleared queue`);
                }).catch((error) => {
                    NotificationService.createFailureNotification(`Could not clear queue`);
                });
            });
        };


        self.xClicked = function () {
            $uibModalInstance.dismiss('cancel');
        };

        self.setQueuesListModalData();

    });
